export default __webpack_public_path__ + "assets/images/1a263fc931e333e69c8544902528cec3.png";